module.exports = __webpack_public_path__ + "static/media/la.abeeee00.svg";